/**
 * Überlappung von Betreuungen eines Pflegebedürftigen.
 *
 * Überlappungen sind erlaubt (Wechseltag: bisherige BK bis 5.10., neue ab
 * 5.10.). Überlappt eine Betreuung eine andere um MEHR als einen Tag,
 * antwortet die v2-API mit 409 `E_CARE_OVERLAP_CONFIRM` + `meta.overlap`;
 * das Formular zeigt dann eine Warnung und sendet nach Bestätigung erneut
 * mit `confirm_overlap: true`.
 */

export interface CareOverlapInfo {
  /** ID der betroffenen (anderen) Betreuung. */
  care_id: number;
  /** Gemeinsame Tage, beide Randtage gezählt. */
  days: number;
  /** Eine der beiden Betreuungen hat kein Enddatum. */
  open_ended?: boolean;
  bk_user_id?: number | null;
  bk_name?: string | null;
  /** YYYY-MM-DD */
  startdatum: string;
  enddatum: string | null;
}

/** `meta.overlap` aus einer 409-Antwort `E_CARE_OVERLAP_CONFIRM` — sonst null. */
export function toCareOverlap(err: unknown): CareOverlapInfo | null {
  const res = (err as { response?: { status?: number; data?: { errors?: Array<{ code?: string }>; meta?: { overlap?: CareOverlapInfo } } } })?.response;
  if (res?.status !== 409) return null;
  if (res.data?.errors?.[0]?.code !== 'E_CARE_OVERLAP_CONFIRM') return null;
  return res.data.meta?.overlap ?? null;
}

/** Fehlertext aus dem v2-Envelope (`errors[0].message`), v1-Form oder Fallback. */
export function careErrorMessage(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: { errors?: Array<{ message?: string }>; message?: string } } })?.response?.data;
  return data?.errors?.[0]?.message ?? data?.message ?? (err instanceof Error && err.message ? err.message : fallback);
}
